import { Checkbox, TableCell, TableRow } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { RootStateOrAny } from 'react-redux'
import { Role } from '../../../enum'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import { useAppSelector } from '../../../store'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import OverflowTooltip from '../../Tooltip/OverflowTooltip'

interface Props {
  handleDeleteClick: (project: Project) => void
  handleEditViewClick: (project: Project) => void
  handleArchiveClick: (project: Project) => void
  isSelected: boolean
  onToggleSelect: (project: Project, isSelected: boolean) => void
  project: Project
}

const ProjectRow = ({
  handleEditViewClick,
  handleDeleteClick,
  handleArchiveClick,
  isSelected,
  onToggleSelect,
  project,
}: Props) => {
  const { users: adminList } = useAppSelector(
    (state: RootStateOrAny) => state.userAdminList
  )
  const { userInfo } = useAppSelector(
    (state: { userLogin: UserLogin }) => state.userLogin
  )

  const createdAt = useDateFormatter(
    project.createdAt ? project.createdAt : new Date(project.createdAt),
    'MM-DD-YYYY'
  )
  const updatedAt = useDateFormatter(project.updatedAt, 'MM-DD-YYYY')

  const assignee = adminList.find(
    (admin: User) => admin._id === project.assignee
  )

  const assigneeName = assignee
    ? `${assignee.firstName} ${assignee.lastName} `
    : 'Unassigned'

  const canDeleteAndArchiveOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
    {
      onClick: () => handleArchiveClick(project),
      label: 'Archive',
    },
    {
      onClick: () => handleDeleteClick(project),
      label: 'Delete',
    },
  ]

  const canDeleteOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
    {
      onClick: () => handleDeleteClick(project),
      label: 'Delete',
    },
  ]

  const canArchiveOptions = [
    {
      onClick: () => {
        handleEditViewClick(project)
      },
      label: 'Edit/View',
    },
    {
      onClick: () => handleArchiveClick(project),
      label: 'Archive',
    },
  ]

  const cannotDeleteOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
  ]

  const handleDoubleClick = () => {
    handleEditViewClick(project)
  }

  return (
    <TableRow onDoubleClick={handleDoubleClick}>
      {userInfo.isAdmin ? (
        <>
          {userInfo.role === Role.MANAGER && (
            <TableCell padding="checkbox">
              <Checkbox
                checked={isSelected}
                onChange={(event) =>
                  onToggleSelect(project, event.target.checked)
                }
              />
            </TableCell>
          )}
          <TableCell>{project.name}</TableCell>
          <TableCell>{project.userName}</TableCell>
          <TableCell>{project.companyName}</TableCell>
          <TableCell>{project.location}</TableCell>
          <TableCell style={{ maxWidth: 250 }}>
            {project.status}
            {project.status === 'Archived' && (
              <OverflowTooltip title={<em>{project.archiveReason}</em>} />
            )}
          </TableCell>
          <TableCell>{assigneeName}</TableCell>
          <TableCell>{createdAt}</TableCell>
          <TableCell>{updatedAt}</TableCell>

          <TableCell>
            <ActionsMenu
              icon={<MoreVert />}
              options={
                userInfo.role === 'Manager' || userInfo.role === 'Support'
                  ? project.status === 'Archived'
                    ? canDeleteOptions
                    : canDeleteAndArchiveOptions
                  : canArchiveOptions
              }
            />
          </TableCell>
        </>
      ) : (
        <>
          <TableCell>{project.name}</TableCell>
          <TableCell>Contract {project.type}</TableCell>
          <TableCell>{project.status}</TableCell>
          <TableCell>{createdAt}</TableCell>
          <TableCell>{updatedAt}</TableCell>
          <TableCell>
            <ActionsMenu
              icon={<MoreVert />}
              options={
                project.status === 'New'
                  ? canDeleteOptions
                  : cannotDeleteOptions
              }
            />
          </TableCell>
        </>
      )}
    </TableRow>
  )
}

export default ProjectRow
